<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Publication" />
            <PubliCation />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import PubliCation from '../Publication/PubliCation.vue'

export default {
    name: 'PublicationPage',
    components: {
        NavBar,
        PageTitle,
        PubliCation,
        FooterComp,
    }
}
</script>